import { render, staticRenderFns } from "./MovieSite.vue?vue&type=template&id=87038736&scoped=true"
import script from "./MovieSite.vue?vue&type=script&lang=js"
export * from "./MovieSite.vue?vue&type=script&lang=js"
import style0 from "./MovieSite.vue?vue&type=style&index=0&id=87038736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87038736",
  null
  
)

export default component.exports